type OSListProps = {
  cpe: string;
  name: string;
};

// Note: many CPEs from the original list are missing
export const osList: OSListProps[] = [
  {
    'cpe': 'cpe:/o:microsoft:windows',
    'name': 'Microsoft Windows',
  },
  {
    'cpe': 'cpe:/o:apple:mac_os',
    'name': 'Apple Mac OS',
  },
  {
    'cpe': 'cpe:/o:apple:iphone_os',
    'name': 'Apple iPhone OS',
  },
  {
    'cpe': 'cpe:/o:google:android',
    'name': 'Google Android Operating System',
  },
  {
    'cpe': 'cpe:/o:microsoft:windows_mobile',
    'name': 'Microsoft Windows Mobile',
  },
  {
    'cpe': 'cpe:/o:linux:linux_kernel',
    'name': 'Linux Kernel',
  },
  {
    'cpe': 'cpe:/o:amiga:amigaos',
    'name': 'AmigaOS',
  },
  {
    'cpe': 'cpe:/o:apple:apple_tv',
    'name': 'Apple TV',
  },
  {
    'cpe': 'cpe:/o:barrelfish:barrelfish',
    'name': 'Barrelfish',
  },
  {
    'cpe': 'cpe:/o:blackberry:blackberry_os',
    'name': 'BlackBerry Os',
  },
  {
    'cpe': 'cpe:/o:bsd:bsd',
    'name': 'BSD',
  },
  {
    'cpe': 'cpe:/o:cyanogenmod:cyanogenmod',
    'name': 'CyanogenMod',
  },
  {
    'cpe': 'cpe:/o:freebsd:freebsd',
    'name': 'FreeBSD',
  },
  {
    'cpe': 'cpe:/o:freenas:freenas',
    'name': 'FreeNAS',
  },
  {
    'cpe': 'cpe:/o:haiku:haiku',
    'name': 'Haiku',
  },
  {
    'cpe': 'cpe:/o:hp:hp-ux',
    'name': 'HP HP-UX',
  },
  {
    'cpe': 'cpe:/o:ipcop:ipcop',
    'name': 'IPCop IPCop',
  },
  {
    'cpe': 'cpe:/o:ipfire:ipfire',
    'name': 'IPFire',
  },
  {
    'cpe': 'cpe:/o:ipxe:ipxe',
    'name': 'iPXE',
  },
  {
    'cpe': 'cpe:/o:ka9q:ka9q',
    'name': 'KA9Q',
  },
  {
    'cpe': 'cpe:/o:minix:minix',
    'name': 'Minix',
  },
  {
    'cpe': 'cpe:/o:netbsd:netbsd',
    'name': 'NetBSD',
  },
  {
    'cpe': 'cpe:/o:nexenta:nexenta',
    'name': 'Nexenta',
  },
  {
    'cpe': 'cpe:/o:next:nextstep',
    'name': 'NEXTSTEP',
  },
  {
    'cpe': 'cpe:/o:nodemcu:nodemcu',
    'name': 'NodeMCU',
  },
  {
    'cpe': 'cpe:/o:openbsd:openbsd',
    'name': 'OpenBSD',
  },
  {
    'cpe': 'cpe:/o:reactos:reactos',
    'name': 'ReactOS',
  },
  {
    'cpe': 'cpe:/o:sco:sco_unix',
    'name': 'SCO UNIX',
  },
  {
    'cpe': 'cpe:/o:sun:sunos',
    'name': 'Sun SunOS',
  },
  {
    'cpe': 'cpe:/o:tintri:tintri_os',
    'name': 'Tintri OS',
  },
  {
    'cpe': 'cpe:/o:tizen:tizen',
    'name': 'Tizen',
  },
  {
    'cpe': 'cpe:/o:adtran:aos',
    'name': 'Adtran AOS',
  },
  {
    'cpe': 'cpe:/o:aerohive:hiveos',
    'name': 'Aerohive HiveOS',
  },
  {
    'cpe': 'cpe:/o:alcatel-lucent:sr_os',
    'name': 'Alcatel-Lucent SR OS',
  },
  {
    'cpe': 'cpe:/o:alliedtelesis:alliedware',
    'name': 'Alliedtelesis AlliedWare',
  },
  {
    'cpe': 'cpe:/o:alliedtelesyn:alliedware',
    'name': 'Alliedtelesyn AlliedWare',
  },
  {
    'cpe': 'cpe:/o:apc:aos',
    'name': 'APC AOS',
  },
  {
    'cpe': 'cpe:/o:apple:a_ux',
    'name': 'Apple A UX',
  },
  {
    'cpe': 'cpe:/o:apple:mac_os_x',
    'name': 'Apple Mac OS X',
  },
  {
    'cpe': 'cpe:/o:apple:mac_os_x_server',
    'name': 'Apple Mac OS X Server',
  },
  {
    'cpe': 'cpe:/o:apple:netbsd',
    'name': 'Apple NetBSD',
  },
  {
    'cpe': 'cpe:/o:arubanetworks:arubaos',
    'name': 'Arubanetworks ArubaOS',
  },
  {
    'cpe': 'cpe:/o:atari:unix',
    'name': 'Atari Unix',
  },
  {
    'cpe': 'cpe:/o:avm:fritzos',
    'name': 'AVM FritzOS',
  },
  {
    'cpe': 'cpe:/o:belllabs:plan_9',
    'name': 'Belllabs Plan 9',
  },
  {
    'cpe': 'cpe:/o:bluebird:superdos',
    'name': 'Bluebird SuperDOS',
  },
  {
    'cpe': 'cpe:/o:bluecoat:sgos',
    'name': 'Blue Coat Systems Proxy Security Gateway OS (SGOS)',
  },
  {
    'cpe': 'cpe:/o:brocade:fabric_os',
    'name': 'Brocade Fabric OS',
  },
  {
    'cpe': 'cpe:/o:brocade:ironware',
    'name': 'Brocade IronWare',
  },
  {
    'cpe': 'cpe:/o:bsdi:bsd_os',
    'name': 'BSDI BSD OS',
  },
  {
    'cpe': 'cpe:/o:caldera:open_unix',
    'name': 'Caldera Open Unix',
  },
  {
    'cpe': 'cpe:/o:checkpoint:gaia_os',
    'name': 'Checkpoint GAiA OS',
  },
  {
    'cpe': 'cpe:/o:checkpoint:ipso',
    'name': 'Checkpoint IPSO',
  },
  {
    'cpe': 'cpe:/o:cisco:acns',
    'name': 'Cisco ACNS',
  },
  {
    'cpe': 'cpe:/o:cisco:aireos',
    'name': 'Cisco AireOS',
  },
  {
    'cpe': 'cpe:/o:cisco:asyncos',
    'name': 'Cisco AsyncOS',
  },
  {
    'cpe': 'cpe:/o:cisco:catos',
    'name': 'Cisco CatOS',
  },
  {
    'cpe': 'cpe:/o:cisco:ios',
    'name': 'Cisco IOS',
  },
  {
    'cpe': 'cpe:/o:cisco:ios_xe',
    'name': 'Cisco IOS XE',
  },
  {
    'cpe': 'cpe:/o:cisco:ios_xr',
    'name': 'Cisco IOS XR',
  },
  {
    'cpe': 'cpe:/o:cisco:mds_9509',
    'name': 'Cisco MDS 9509',
  },
  {
    'cpe': 'cpe:/o:cisco:nexus_5000',
    'name': 'Cisco Nexus 5000',
  },
  {
    'cpe': 'cpe:/o:cisco:nexus_5010',
    'name': 'Cisco Nexus 5010',
  },
  {
    'cpe': 'cpe:/o:cisco:nexus_5548',
    'name': 'Cisco Nexus 5548',
  },
  {
    'cpe': 'cpe:/o:cisco:nexus_5548p',
    'name': 'Cisco Nexus 5548P',
  },
  {
    'cpe': 'cpe:/o:cisco:nexus_7000',
    'name': 'Cisco Nexus 7000',
  },
  {
    'cpe': 'cpe:/o:cisco:nexus_7010',
    'name': 'Cisco Nexus 7010',
  },
  {
    'cpe': 'cpe:/o:cisco:nexus_v1000',
    'name': 'Cisco Nexus V1000',
  },
  {
    'cpe': 'cpe:/o:cisco:nx_os',
    'name': 'Cisco NX OS',
  },
  {
    'cpe': 'cpe:/o:cisco:pix_os',
    'name': 'Cisco PIX OS',
  },
  {
    'cpe': 'cpe:/o:cisco:san_os',
    'name': 'Cisco SAN OS',
  },
  {
    'cpe': 'cpe:/o:citrix:xenserver',
    'name': 'Citrix XenServer',
  },
  {
    'cpe': 'cpe:/o:compaq:tru64',
    'name': 'Compaq Tru64',
  },
  {
    'cpe': 'cpe:/o:cray:unicos',
    'name': 'Cray UNICOS',
  },
  {
    'cpe': 'cpe:/o:crestron:2_series',
    'name': 'Crestron 2 Series',
  },
  {
    'cpe': 'cpe:/o:data_general:dg%2fux',
    'name': 'Data General Dg%2Fux',
  },
  {
    'cpe': 'cpe:/o:dec:digital_unix',
    'name': 'DEC Digital UNIX',
  },
  {
    'cpe': 'cpe:/o:dec:dnas',
    'name': 'DEC DNAS',
  },
  {
    'cpe': 'cpe:/o:dec:openvms',
    'name': 'DEC OpenVMS',
  },
  {
    'cpe': 'cpe:/o:dec:osf_1',
    'name': 'DEC OSF 1',
  },
  {
    'cpe': 'cpe:/o:dec:rsx_11m_plus',
    'name': 'DEC RSX 11M PLUS',
  },
  {
    'cpe': 'cpe:/o:dec:rsx-11m-plus',
    'name': 'DEC RSX-11M-PLUS',
  },
  {
    'cpe': 'cpe:/o:dec:tops_20',
    'name': 'DEC TOPS 20',
  },
  {
    'cpe': 'cpe:/o:dec:ultrix',
    'name': 'DEC Ultrix',
  },
  {
    'cpe': 'cpe:/o:dell:idrac6_firmware',
    'name': 'Dell iDRAC6 Monolithic firmware',
  },
  {
    'cpe': 'cpe:/o:dell:netbsd',
    'name': 'Dell NetBSD',
  },
  {
    'cpe': 'cpe:/o:dell:network_operating_system',
    'name': 'Dell Network Operating System',
  },
  {
    'cpe': 'cpe:/o:digi:net_os',
    'name': 'Digi NET OS',
  },
  {
    'cpe': 'cpe:/o:dragonflybsd:dragonfly_bsd',
    'name': 'Dragonflybsd DragonFly BSD',
  },
  {
    'cpe': 'cpe:/o:ecoscentric:ecos',
    'name': 'eCosCentric eCos',
  },
  {
    'cpe': 'cpe:/o:elfiq:eos',
    'name': 'Elfiq EOS',
  },
  {
    'cpe': 'cpe:/o:emc:vnx_oe_for_file',
    'name': 'EMC VNX OE for File',
  },
  {
    'cpe': 'cpe:/o:eric_bishop:gargoyle',
    'name': 'Eric Bishop Gargoyle',
  },
  {
    'cpe': 'cpe:/o:ethernut:nut_os',
    'name': 'Ethernut Nut OS',
  },
  {
    'cpe': 'cpe:/o:ethzurich:bluebottle',
    'name': 'Ethzurich Bluebottle',
  },
  {
    'cpe': 'cpe:/o:expresslogic:threadx',
    'name': 'Expresslogic ThreadX',
  },
  {
    'cpe': 'cpe:/o:extremenetworks:extremeware',
    'name': 'Extremenetworks ExtremeWare',
  },
  {
    'cpe': 'cpe:/o:extremenetworks:extremexos',
    'name': 'Extremenetworks ExtremeXOS',
  },
  {
    'cpe': 'cpe:/o:f5:bsd_os',
    'name': 'F5 BSD OS',
  },
  {
    'cpe': 'cpe:/o:f5:tmos',
    'name': 'F5 Networks Traffic Management Operating System (TMOS)',
  },
  {
    'cpe': 'cpe:/o:force10:ftos',
    'name': 'Force10 FTOS',
  },
  {
    'cpe': 'cpe:/o:force10:sftos',
    'name': 'Force10 SFTOS',
  },
  {
    'cpe': 'cpe:/o:fortinet:fortios',
    'name': 'Fortinet FortiOS',
  },
  {
    'cpe': 'cpe:/o:foundrynet:ironware',
    'name': 'Foundrynet IronWare',
  },
  {
    'cpe': 'cpe:/o:fujitsu:bs2000_osd',
    'name': 'Fujitsu BS2000 OSD',
  },
  {
    'cpe': 'cpe:/o:fujitsu:reliantunix',
    'name': 'Fujitsu ReliantUNIX',
  },
  {
    'cpe': 'cpe:/o:george_robotics:micropython',
    'name': 'George Robotics Micropython',
  },
  {
    'cpe': 'cpe:/o:gnu:hurd',
    'name': 'GNU Hurd',
  },
  {
    'cpe': 'cpe:/o:greenhills:rtos',
    'name': 'Greenhills RTOS',
  },
  {
    'cpe': 'cpe:/o:h3c:comware',
    'name': 'H3C Comware',
  },
  {
    'cpe': 'cpe:/o:hay_systems:hsl_2.75g_femtocell',
    'name': 'Hay Systems HSL 2.75G Femtocell',
  },
  {
    'cpe': 'cpe:/o:hp:comware',
    'name': 'HP Comware',
  },
  {
    'cpe': 'cpe:/o:hp:ilo',
    'name': 'HP iLO',
  },
  {
    'cpe': 'cpe:/o:hp:mpe_ix',
    'name': 'HP MPE iX',
  },
  {
    'cpe': 'cpe:/o:hp:nonstop_os',
    'name': 'HP NonStop OS',
  },
  {
    'cpe': 'cpe:/o:hp:openvms',
    'name': 'HP OpenVMS',
  },
  {
    'cpe': 'cpe:/o:hp:tru64',
    'name': 'HP Tru64',
  },
  {
    'cpe': 'cpe:/o:huawei:vrp',
    'name': 'Huawei VRP',
  },
  {
    'cpe': 'cpe:/o:ibm:4690_operating_system',
    'name': 'IBM 4690 Operating system',
  },
  {
    'cpe': 'cpe:/o:ibm:aix',
    'name': 'IBM AIX',
  },
  {
    'cpe': 'cpe:/o:ibm:i',
    'name': 'IBM I',
  },
  {
    'cpe': 'cpe:/o:ibm:i5os',
    'name': 'IBM I5Os',
  },
  {
    'cpe': 'cpe:/o:ibm:os_390',
    'name': 'IBM OS 390',
  },
  {
    'cpe': 'cpe:/o:ibm:os_400',
    'name': 'IBM OS 400',
  },
  {
    'cpe': 'cpe:/o:ibm:os2',
    'name': 'IBM Os2',
  },
  {
    'cpe': 'cpe:/o:ibm:z_vm',
    'name': 'IBM z VM',
  },
  {
    'cpe': 'cpe:/o:ibm:zos',
    'name': 'IBM Zos',
  },
  {
    'cpe': 'cpe:/o:illumos:openindiana',
    'name': 'illumos OpenIndiana',
  },
  {
    'cpe': 'cpe:/o:imperva:securesphere',
    'name': 'Imperva SecureSphere',
  },
  {
    'cpe': 'cpe:/o:infrant:raidiator',
    'name': 'Infrant RAIDiator',
  },
  {
    'cpe': 'cpe:/o:interpeak:ipcom',
    'name': 'Interpeak IPCOM',
  },
  {
    'cpe': 'cpe:/o:ipadownersassociation:ipad_os',
    'name': 'Ipadownersassociation IPAD OS',
  },
  {
    'cpe': 'cpe:/o:ironport:asyncos',
    'name': 'IronPort AsyncOS',
  },
  {
    'cpe': 'cpe:/o:isilon:onefs',
    'name': 'Isilon OneFS',
  },
  {
    'cpe': 'cpe:/o:joyent:smartos',
    'name': 'Joyent SmartOS',
  },
  {
    'cpe': 'cpe:/o:juniper:ive_os',
    'name': 'Juniper IVE OS',
  },
  {
    'cpe': 'cpe:/o:juniper:junos',
    'name': 'Juniper JUNOS',
  },
  {
    'cpe': 'cpe:/o:kw-software:proconos',
    'name': 'KW-Software ProConOS',
  },
  {
    'cpe': 'cpe:/o:lancom:lcos',
    'name': 'Lancom LCOS',
  },
  {
    'cpe': 'cpe:/o:lantronix:evolution_os',
    'name': 'Lantronix Evolution OS',
  },
  {
    'cpe': 'cpe:/o:linksys:spa3102_voice_gateway_with_router_firmware',
    'name': 'Linksys SPA3102 Voice Gateway With Router Firmware',
  },
  {
    'cpe': 'cpe:/o:lucent:comos',
    'name': 'Lucent ComOS',
  },
  {
    'cpe': 'cpe:/o:microsoft:ms-dos',
    'name': 'Microsoft MS-DOS',
  },
  {
    'cpe': 'cpe:/o:microsoft:windows_10',
    'name': 'Microsoft Windows 10',
  },
  {
    'cpe': 'cpe:/o:microsoft:windows_2000',
    'name': 'Microsoft Windows 2000',
  },
  {
    'cpe': 'cpe:/o:microsoft:windows_2008',
    'name': 'Microsoft Windows 2008',
  },
  {
    'cpe': 'cpe:/o:microsoft:windows_2012',
    'name': 'Microsoft Windows 2012',
  },
  {
    'cpe': 'cpe:/o:microsoft:windows_7',
    'name': 'Microsoft Windows 7',
  },
  {
    'cpe': 'cpe:/o:microsoft:windows_8',
    'name': 'Windows 8',
  },
  {
    'cpe': 'cpe:/o:microsoft:windows_8.1',
    'name': 'Microsoft Windows 8.1',
  },
  {
    'cpe': 'cpe:/o:microsoft:windows_95',
    'name': 'Microsoft Windows 95',
  },
  {
    'cpe': 'cpe:/o:microsoft:windows_98',
    'name': 'Microsoft Windows 98',
  },
  {
    'cpe': 'cpe:/o:microsoft:windows_ce',
    'name': 'Microsoft Windows CE',
  },
  {
    'cpe': 'cpe:/o:microsoft:windows_embedded_compact_7',
    'name': 'Microsoft Windows Embedded Compact 7',
  },
  {
    'cpe': 'cpe:/o:microsoft:windows_me',
    'name': 'Microsoft Windows Me',
  },
  {
    'cpe': 'cpe:/o:microsoft:windows_nt',
    'name': 'Microsoft Windows NT',
  },
  {
    'cpe': 'cpe:/o:microsoft:windows_server_2003',
    'name': 'Microsoft Windows Server 2003',
  },
  {
    'cpe': 'cpe:/o:microsoft:windows_server_2008',
    'name': 'Microsoft Windows Server 2008',
  },
  {
    'cpe': 'cpe:/o:microsoft:windows_server_2012',
    'name': 'Microsoft Windows Server 2012',
  },
  {
    'cpe': 'cpe:/o:microsoft:windows_server_2016',
    'name': 'Microsoft Windows Server 2016',
  },
  {
    'cpe': 'cpe:/o:microsoft:windows_vista',
    'name': 'Microsoft Windows Vista',
  },
  {
    'cpe': 'cpe:/o:microsoft:windows_xp',
    'name': 'Microsoft Windows XP',
  },
  {
    'cpe': 'cpe:/o:microware:os_9',
    'name': 'Microware OS 9',
  },
  {
    'cpe': 'cpe:/o:mikrotik:routeros',
    'name': 'MikroTik RouterOS',
  },
  {
    'cpe': 'cpe:/o:motorola:v_88',
    'name': 'Motorola V 88',
  },
  {
    'cpe': 'cpe:/o:motorola:windows_ce',
    'name': 'Motorola Windows CE',
  },
  {
    'cpe': 'cpe:/o:motorola:wing',
    'name': 'Motorola WiNG',
  },
  {
    'cpe': 'cpe:/o:netapp:data_ontap',
    'name': 'NetApp Data ONTAP',
  },
  {
    'cpe': 'cpe:/o:netgear:raidiator',
    'name': 'NETGEAR RAIDiator firmware for ReadyNAS network storage products',
  },
  {
    'cpe': 'cpe:/o:netopia:soc_os',
    'name': 'Netopia SOC OS',
  },
  {
    'cpe': 'cpe:/o:next:openstep',
    'name': 'NeXT OPENSTEP',
  },
  {
    'cpe': 'cpe:/o:nokia:ipso',
    'name': 'Nokia IPSO',
  },
  {
    'cpe': 'cpe:/o:nokia:symbian_os',
    'name': 'Nokia Symbian OS',
  },
  {
    'cpe': 'cpe:/o:novell:netware',
    'name': 'Novell NetWare',
  },
  {
    'cpe': 'cpe:/o:ontime:rtos',
    'name': 'Ontime RTOS',
  },
  {
    'cpe': 'cpe:/o:oracle:jrockit',
    'name': 'Oracle JRockit',
  },
  {
    'cpe': 'cpe:/o:oracle:solaris',
    'name': 'Oracle Solaris',
  },
  {
    'cpe': 'cpe:/o:oracle:virtualbox',
    'name': 'Oracle Virtualbox',
  },
  {
    'cpe': 'cpe:/o:oracle:vm_server',
    'name': 'Oracle VM Server for SPARC',
  },
  {
    'cpe': 'cpe:/o:patton:smartware',
    'name': 'Patton SmartWare',
  },
  {
    'cpe': 'cpe:/o:pc-bsd:pc_bsd',
    'name': 'PC-BSD PC BSD',
  },
  {
    'cpe': 'cpe:/o:pharlap:ets',
    'name': 'Pharlap ETS',
  },
  {
    'cpe': 'cpe:/o:planet:microc_os_ii',
    'name': 'Planet MicroC OS II',
  },
  {
    'cpe': 'cpe:/o:polycom:psos',
    'name': 'Polycom pSOS',
  },
  {
    'cpe': 'cpe:/o:precisesoftwaretechnologies:mqx',
    'name': 'Precisesoftwaretechnologies MQX',
  },
  {
    'cpe': 'cpe:/o:qnap:qts',
    'name': 'QNAP QTS',
  },
  {
    'cpe': 'cpe:/o:qnx:rtos',
    'name': 'QNX RTOS',
  },
  {
    'cpe': 'cpe:/o:quarterdeck:desqview_x',
    'name': 'Quarterdeck DESQview X',
  },
  {
    'cpe': 'cpe:/o:radware:apsolute_os',
    'name': 'Radware APsolute OS',
  },
  {
    'cpe': 'cpe:/o:redback:smartedge_os',
    'name': 'Redback SmartEdge OS',
  },
  {
    'cpe': 'cpe:/o:rim:blackberry',
    'name': 'RIM BlackBerry',
  },
  {
    'cpe': 'cpe:/o:rim:blackberry_playbook_os',
    'name': 'Research In Motion Blackberry Playbook Tablet OS',
  },
  {
    'cpe': 'cpe:/o:rim:tablet_os',
    'name': 'RIM Tablet OS',
  },
  {
    'cpe': 'cpe:/o:riscosltd:risc_os',
    'name': 'Riscosltd RISC OS',
  },
  {
    'cpe': 'cpe:/o:riverbed:rios',
    'name': 'Riverbed RiOS',
  },
  {
    'cpe': 'cpe:/o:ruggedcom:ros',
    'name': 'RuggedCom ROS',
  },
  {
    'cpe': 'cpe:/o:samsung:bada',
    'name': 'Samsung Bada',
  },
  {
    'cpe': 'cpe:/o:samsung:symbian_os',
    'name': 'Samsung Symbian OS',
  },
  {
    'cpe': 'cpe:/o:sco:openserver',
    'name': 'SCO OpenServer',
  },
  {
    'cpe': 'cpe:/o:sco:unixware',
    'name': 'SCO UnixWare',
  },
  {
    'cpe': 'cpe:/o:securecomputing:secureos',
    'name': 'Securecomputing SecureOS',
  },
  {
    'cpe': 'cpe:/o:sequent:dynix',
    'name': 'Sequent DYNIX',
  },
  {
    'cpe': 'cpe:/o:sgi:irix',
    'name': 'SGI IRIX',
  },
  {
    'cpe': 'cpe:/o:siemens:sinix',
    'name': 'Siemens SINIX',
  },
  {
    'cpe': 'cpe:/o:sipura:spa1001_voice_gateway_with_router_firmware',
    'name': 'Sipura SPA1001 Voice Gateway With Router Firmware',
  },
  {
    'cpe': 'cpe:/o:sipura:spa2102_phone_adapter_with_router_firmware',
    'name': 'Sipura Spa2102 phone adapter With Router Firmware',
  },
  {
    'cpe': 'cpe:/o:sipura:spa3000_voice_gateway_with_router_firmware',
    'name': 'Sipura SPA3000 Voice Gateway With Router Firmware',
  },
  {
    'cpe': 'cpe:/o:sonicwall:aventail_ex-1500',
    'name': 'SonicWALL Aventail EX-1500',
  },
  {
    'cpe': 'cpe:/o:sonicwall:aventail_ex-6000',
    'name': 'SonicWALL Aventail EX-6000',
  },
  {
    'cpe': 'cpe:/o:sonicwall:sonicos',
    'name': 'SonicWALL SonicOS',
  },
  {
    'cpe': 'cpe:/o:sonicwall:tz_170',
    'name': 'SonicWALL TZ 170',
  },
  {
    'cpe': 'cpe:/o:sony:smp-n200',
    'name': 'Sony SMP-N200',
  },
  {
    'cpe': 'cpe:/o:sonyericsson:symbian_os',
    'name': 'Sonyericsson Symbian OS',
  },
  {
    'cpe': 'cpe:/o:sun:opensolaris',
    'name': 'Sun OpenSolaris',
  },
  {
    'cpe': 'cpe:/o:supermicro:intelligent_platform_management_firmware',
    'name': 'Supermicro Intelligent Platform Management Firmware',
  },
  {
    'cpe': 'cpe:/o:syllable:desktop',
    'name': 'Syllable Desktop',
  },
  {
    'cpe': 'cpe:/o:symbianos:symbian_os',
    'name': 'Symbianos Symbian OS',
  },
  {
    'cpe': 'cpe:/o:tandberg:netbsd',
    'name': 'Tandberg NetBSD',
  },
  {
    'cpe': 'cpe:/o:tandem:guardian',
    'name': 'Tandem Guardian',
  },
  {
    'cpe': 'cpe:/o:tektronix:os_350',
    'name': 'Tektronix os 350',
  },
  {
    'cpe': 'cpe:/o:tenasys:irmx',
    'name': 'TenAsys iRMX',
  },
  {
    'cpe': 'cpe:/o:toshiba:4690_operating_system',
    'name': 'Toshiba 4690 Operating system',
  },
  {
    'cpe': 'cpe:/o:tripplite:netos',
    'name': 'Tripplite NetOS',
  },
  {
    'cpe': 'cpe:/o:ubicom:ipos',
    'name': 'Ubicom ipOS',
  },
  {
    'cpe': 'cpe:/o:ubnt:airos',
    'name': 'Ubnt AirOS',
  },
  {
    'cpe': 'cpe:/o:vmware:esx',
    'name': 'VMware ESX',
  },
  {
    'cpe': 'cpe:/o:vmware:esxi',
    'name': 'VMware ESXi',
  },
  {
    'cpe': 'cpe:/o:watchguard:fireware',
    'name': 'WatchGuard Fireware',
  },
  {
    'cpe': 'cpe:/o:westerndigital:linux',
    'name': 'Westerndigital Linux',
  },
  {
    'cpe': 'cpe:/o:westerndigital:wd_tv',
    'name': 'Westerndigital WD TV',
  },
  {
    'cpe': 'cpe:/o:windriver:psosystem',
    'name': 'Windriver pSOSystem',
  },
  {
    'cpe': 'cpe:/o:windriver:vxworks',
    'name': 'Windriver VxWorks',
  },
  {
    'cpe': 'cpe:/o:wyse:thinos',
    'name': 'Wyse ThinOS',
  },
  {
    'cpe': 'cpe:/o:xeu.com:ecomstation',
    'name': 'XEU.com eComStation',
  },
  {
    'cpe': 'cpe:/o:zyxel:zld',
    'name': 'ZyXEL ZLD',
  },
  {
    'cpe': 'cpe:/o:zyxel:zynos',
    'name': 'ZyXEL ZyNOS',
  },
];


export function getOSString(cpe: string, fallback = 'Unknown') {
  for (const os of osList) {
    if (os.cpe === cpe) {
      return os.name;
    }
  }
  return fallback;
}
